module.exports = __webpack_public_path__ + "static/img/14004B_2_3_R_201903122_LC.44efc0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14004B_2_3_R_201903122_LC.png
// module id = NZ6p
// module chunks = 0